import { z } from "zod";

export const cancelMeetingSchema = z
	.object({
		message: z.string().max(1000).optional(),
	})
	.strict();

export type CancelMeetingPayload = z.infer<typeof cancelMeetingSchema>;
